import { useCallback, useMemo } from "react";
import { useEffect } from "react";
import { useState } from "react";
import styles from "./Details.module.css";
import { ReactComponent as BackIcon } from "./../../../../assets/svg/bottom-arrow.svg";
import { useTranslation } from "react-i18next";
import FlipDownCounter from "../Item/FlipDownCounter";
import { calculateRemainingTime, timeAgo } from "../../../../base/utils";
import { useSearchParams } from "react-router-dom";
import Loading from "../../../components/Loading/Loading";
import { API } from "../../../../request/api";
import { Note } from "../../../../helbest";
import { Drawer } from "antd";
import { _remove_notification } from "../../../../store/actions/notification_actions";
import { LangLink } from "../../../components/LangLink/LangLink";
import CircleDownCounter from "../Item/CircleDownCounter";

const Details = () => {
  const [open, setOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [countDown, setCountDown] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();

  const notificationId = searchParams.get("id");

  const origin = window.location.origin;

  const linkIsInternal = useMemo(() => {
    if (data?.link) {
      const index = data.link.indexOf(origin);
      if (index !== -1) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }, [JSON.stringify(data)]);

  const linkHandler = useCallback(
    (link) => {
      const index = data.link.indexOf(origin);
      if (index !== -1) {
        return link.slice(index + origin.length);
      } else {
        return link;
      }
    },
    [JSON.stringify(data)],
  );

  useEffect(() => {
    if (open && notificationId) {
      setLoading(true);
      API.get
        .retrieveNotification(notificationId)
        .then((response) => {
          if (response.code === 200) {
            setData(response.data);
            if (response.data.expires_in) {
              setCountDown(
                calculateRemainingTime(
                  response.data.send_time,
                  response.data.expires_in,
                ),
              );
            }
          } else if (response.code === 404) {
            closeHandler();
          } else {
            Note.error(response.message);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [open, notificationId]);

  useEffect(() => {
    if (notificationId) {
      setOpen(true);
    } else {
      setOpen(false);
      setData(null);
    }
  }, [notificationId]);

  function closeHandler() {
    setSearchParams((prevState) => {
      prevState.delete("id");
      return prevState;
    });
  }

  return (
    <Drawer
      open={open}
      height={"100%"}
      placement="bottom"
      closable={false}
      styles={{ body: { padding: "0" } }}
    >
      <div className={styles.Header}>
        <div onClick={closeHandler} className={styles.BackContainer}>
          <BackIcon style={{ rotate: i18n.dir() === "rtl" ? "180deg" : "0" }} />
        </div>
        <span className={styles.HeaderTitle}>{t("notifications.title")}</span>
      </div>
      <div className={styles.ContentContainer}>
        {loading && (
          <div className="text-center mt-5">
            <Loading />
          </div>
        )}
        {data && (
          <div
            className={`${styles.Content} ${data.is_expired ? styles.expiredContent : ""}`}
          >
            <div className={styles.ContentTitle}>
              <div className={styles.TitleContainer}>
                <div>
                  <h3 className={styles.Title}>
                    {data.subject}
                    {data.is_expired ? ` ${t("notifications.expired")}` : ""}
                  </h3>
                  {data.message && (
                    <div
                      className={styles.description}
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: data.message,
                      }}
                    />
                  )}
                </div>
                {data.expires_in === null ? (
                  <div className={styles.ExpireDate}>
                    {timeAgo(data.send_time, i18n.language)}
                  </div>
                ) : countDown ? (
                  <CircleDownCounter
                    key={countDown}
                    onExpired={() => {
                      closeHandler();
                    }}
                    initialSeconds={countDown}
                  />
                ) : null}
              </div>
            </div>
            {data.link && linkIsInternal && data.image ? (
              <LangLink
                to={linkHandler(data.link)}
                className={styles.ImageLink}
              >
                <img
                  src={process.env.REACT_APP_API_REST_URL + data.image}
                  className={styles.Image}
                  alt="img"
                />
              </LangLink>
            ) : data.link && !linkIsInternal && data.image ? (
              <a
                href={linkHandler(data.link)}
                target="_blank"
                rel="noreferrer"
                className={styles.ImageLink}
              >
                <img
                  src={process.env.REACT_APP_API_REST_URL + data.image}
                  className={styles.Image}
                  alt="img"
                />
              </a>
            ) : data.image ? (
              <img
                src={process.env.REACT_APP_API_REST_URL + data.image}
                className={styles.Image}
                alt="img"
              />
            ) : null}
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default Details;
